import { render, staticRenderFns } from "./topology.vue?vue&type=template&id=bf168ba6"
import script from "./topology.vue?vue&type=script&lang=ts"
export * from "./topology.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports